<script>
    import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "@sveltestrap/sveltestrap";
    import TokenDetails from "../snippets/TokenDetails.svelte";
    import ButtonLine from "../snippets/ButtonLine.svelte";
    import {focusLastModalElement, handleStaticModalToggle, modalClassName, modalFade} from "./utils.js";

    let { showModal = $bindable(false), token, ...rest } = $props();

    const toggle = () => (showModal = !showModal);
    const handleModalToggle = handleStaticModalToggle(toggle);
</script>

<Modal 
    {...rest}
    isOpen={showModal}
    toggle={handleModalToggle}
    fade={$modalFade}
    modalClassName={$modalClassName}
    scrollable
    size="xl"
    on:open={() => focusLastModalElement(".modal .confirm-button")}
>
    <ModalHeader toggle={handleModalToggle}>Zertifikatsinformation</ModalHeader>
    <ModalBody>
        <TokenDetails {token} />
    </ModalBody>
    <ModalFooter>
        <ButtonLine>
            <Button color="primary" class="confirm-button" on:click={toggle} data-test-id="tokenDetailsModal-button-ok">OK</Button>
        </ButtonLine>
    </ModalFooter>
</Modal>
